import React from "react";
export const User = () => (
  <svg viewBox="0 0 11 16">
    <path d="M5.5 8c1.47 0 2.67-1.19 2.67-2.67S6.97 2.67 5.5 2.67 2.83 3.86 2.83 5.33 4.03 8 5.5 8zm0 1.33C3.72 9.33.17 10.22.17 12v.67c0 .37.3.67.67.67h9.33c.37 0 .67-.3.67-.67V12c-.01-1.77-3.56-2.67-5.34-2.67z" />
  </svg>
);
